import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { SignupPage } from "./pages/SignupPage";
import { TermsAndConditionsPage } from "./pages/TermsAndConditionsPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<SignupPage />} />
          <Route path="/terms" element={<TermsAndConditionsPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
